export default (function () {
  function RequestStack (Vue, options) {
    this.watch = new Vue({
      data: function () {
        return {
          stack: [],
          maxConcurrentRequests: 3,
          concurrentRequests: []
        }
      },
      methods: {
        execRequest: function (request) {
          let cancelToken = (request.data && request.data.cancelToken) ? {cancelToken: request.data.cancelToken } : null
          this.axios[request.method](request.url, request.data, cancelToken)
            .then((response) => {
              request.resolve(response)
            })
            .catch((error) => {
              request.reject(error)
            })
            .finally(() => {
              this.concurrentRequests.splice(this.concurrentRequests.indexOf(request, 1))
            })

          this.concurrentRequests.push(request)
        },
        popRequests: function () {
          let stack = this.stack.slice(0)

          stack.sort((request1, request2) => {
            return request1.priority - request2.priority
          })

          stack.forEach((request) => {
            if (this.concurrentRequests.length < (this.maxConcurrentRequests - 1)) {
              this.execRequest(request)
              this.stack.splice(this.stack.indexOf(request), 1)
            } else if (this.concurrentRequests.length < this.maxConcurrentRequests) {
              this.concurrentRequests.every((concurrentRequest) => {
                if (concurrentRequest !== request && concurrentRequest.priority > request.priority) {
                  this.execRequest(request)
                  this.stack.splice(this.stack.indexOf(request), 1)
                  return false
                }
              })
            }
          })
        }
      },

      watch: {
        concurrentRequests: function () {
          this.popRequests()
        },
        stack: function (stack) {
          this.popRequests()
        }
      }
    })
  }

  RequestStack.prototype.add = function (method, url, data, priority) {
    return new Promise((resolve, reject) => {
      this.watch.stack.push({method, url, data, priority, resolve, reject})
    })
  }

  RequestStack.prototype.flush = function () {
    this.watch.stack = []
  }

  return RequestStack
})()



// WEBPACK FOOTER //
// ./src/plugins/requestStack/requestStack.js